export function isHttpNotFound(error: unknown): boolean {
  return Boolean(
    error &&
      typeof error === "object" &&
      (error as { response?: { status?: number } }).response?.status === 404
  );
}

function readableMessage(value: string): string | undefined {
  const text = value.trim();
  if (!text) return undefined;
  // Proxy/Odoo 404 pages are HTML; never put them in a toast.
  if (text.startsWith("<") || /<\/?[a-z][\s\S]*>/i.test(text)) return undefined;
  return text;
}

/** Preserve API validation messages before Redux serializes Axios errors. */
export function getCartErrorMessage(error: unknown): string | undefined {
  if (typeof error === "string") return readableMessage(error);
  if (!error || typeof error !== "object") return undefined;
  const value = error as Record<string, any>;
  const body = value.response?.data;
  return getCartErrorMessage(body) ||
    (typeof value.message === "string" ? readableMessage(value.message) : undefined) ||
    getCartErrorMessage(value.error) || getCartErrorMessage(value.result);
}

/** Some endpoints report validation errors in an otherwise successful HTTP response. */
export function getCartResponseError(data: any): string | null | undefined {
  if (!data || typeof data !== "object") return undefined;
  if (data.error || data.success === false) return getCartErrorMessage(data) ?? null;
  if (
    typeof data.message === "string" &&
    !/^\s*success/i.test(data.message) &&
    data.success !== true &&
    !data.cart_id && !data.result && !data.data
  ) {
    return data.message.trim() || null;
  }
  const resultError = getCartResponseError(data.result);
  return resultError !== undefined ? resultError : getCartResponseError(data.data);
}
